import React from 'react'
import { connect } from 'react-redux';
import { setPerformedMultiLicenseExclusion } from '../../state/actions/exclusions'

const mapDispatchAsProps = dispatch => ({
	setPerformedMultiLicenseExclusion: (value) => dispatch(setPerformedMultiLicenseExclusion(value))
})
const mapStateAsProps = state => ({
	performedMultiLicenseExclusion: state.elementExclusion.performedMultiLicenseExclusion
})
class Mitigator extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			type: "advice",
			excludeDialog: {
				description: '',
			},
			elementToMitigate: {
				title: ''
			},
			doRecompute: false,
			applyToAllBranches: false,
			expiryOption: this.defaultExpiry(),
			customExpiry: "",
			expiryError: false
		}

		this.excludeDialogTextarea = React.createRef();
		this.excludeComponent = React.createRef();
		this.autoRecompute = React.createRef();

	}

	// The stored value is a free number from the account configuration API, so it goes
	// through optionValueForDays rather than being trusted directly - that's also what
	// makes an absent or unrecognised value fall back to "never" instead of nothing.
	defaultExpiry = () => {
		const configuration = this.props.accountInfo
			&& this.props.accountInfo.properties
			&& this.props.accountInfo.properties.configuration
		return window.ExclusionExpiry.optionValueForDays(configuration && configuration.defaultExclusionExpiry)
	}

	componentDidMount() {
		// This component is mounted once and reused for every exclusion in the
		// report, so nothing clears the checkbox on its own. A value that
		// survived between openings would silently widen a later, unrelated
		// exclusion to every branch.
		//
		// shown.bs.modal fires every time the dialog becomes visible, whatever
		// opened it and whether or not the exclusion element changed. The
		// element-comparison signal the parent passes (shouldSetDefaultState)
		// cannot promise that, which is why this handler exists instead of
		// relying on a prop change.
		window.$("#exclude-dialog").on("shown.bs.modal", this.resetPerExclusionState)
	}

	componentWillUnmount() {
		window.$("#exclude-dialog").off("shown.bs.modal", this.resetPerExclusionState)
	}

	// A stable reference, so componentWillUnmount removes the handler it added.
	// A custom date left behind would silently expire the next, unrelated exclusion on a day
	// nobody chose for it, so it is cleared here alongside the option that reveals it.
	resetPerExclusionState = () => {
		this.setState({
			applyToAllBranches: false,
			expiryOption: this.defaultExpiry(),
			customExpiry: "",
			expiryError: false
		})
	}

	setApplyToAllBranches = (e) => {
		this.setState({ applyToAllBranches: e.target.checked })
	}

	setExpiryOption = (e) => {
		this.setState({ expiryOption: e.target.value, expiryError: false })
	}

	setCustomExpiry = (e) => {
		this.setState({ customExpiry: e.target.value, expiryError: false })
	}

	// A duration always resolves to a date; a custom day only does if it can be read and still
	// lies ahead. Without this the modal would send no expiry at all, which the API stores as
	// never expiring - a permanent exclusion, from somebody who asked for a date.
	isExpiryValid = () => {
		if (this.state.expiryOption !== window.ExclusionExpiry.CUSTOM) return true
		return window.ExclusionExpiry.isValidCustomExpiry(this.state.customExpiry)
	}

	setDescriptionText = (e) => {
		const { excludeDialog } = this.state;
		this.setState({ excludeDialog: { ...excludeDialog, error: false, description: e.target.value } })
		if(e.target.value.length) this.props.setCloseModalConfirmCb(this.confirmHandler)
		else this.props.setCloseModalConfirmCb(null)
	}

	setGlobalExclusion = (e) => {
		this.globalExclusion = e.target.checked;
	}

	async excludeNonSecurity(exclusionElement, description, counter=0, all=1, expiry = null) {
		delete exclusionElement.report;
		let { content, libraryContent } = exclusionElement;
		let transitive = false
		if (exclusionElement.domain === "security:transitive") {
			transitive = true
			content = { ...content, ...libraryContent, transitive: true };
		}
		await this.processMitigation(exclusionElement, description, content, counter, all, transitive, expiry)
	}
	async excludeMultiLicenses(exclusionElements, description, expiry = null) {
		try {
			for(let i = 0; i < exclusionElements.length; i++) {
				await this.excludeNonSecurity(exclusionElements[i], description, i, exclusionElements.length, expiry)
			}
			this.props.setPerformedMultiLicenseExclusion(true)
		} catch(e) {
			console.log("error occured performing multi license exclusions", e)
		}
	}
	confirmDescription = async () => {
		let { exclusionElement, isMultiple } = this.props;
		const { excludeDialog } = this.state;
		const { description } = excludeDialog;
		if (this.isDescriptionValid(description)) {
			// Checked after the description, so the modal complains about its fields in the
			// order they are read, and before anything below clears or closes them.
			if (!this.isExpiryValid()) {
				return this.setState({ expiryError: true })
			}
			// Resolved once for the whole action: processMitigation runs per item in a batch,
			// and re-resolving inside it would let a batch straddling midnight expire on two
			// different days.
			const expiry = window.ExclusionExpiry.expiryDateFor(this.state.expiryOption, Date.now(), this.state.customExpiry);
			this.excludeDialogTextarea.current.value = ""
			window.$("#exclude-dialog").modal("toggle");
			if(!isMultiple) {
				if (exclusionElement.domain === "security") {
					if (this.globalExclusion) {
						const { adviceContent, cveContent, libraryContent } = exclusionElement;
						const { report } = exclusionElement;
						delete exclusionElement.report;
						if (this.state.type === "advice") {
							const all = report.advices.length;
							let counter = all - 1;
							const content = { ...exclusionElement.content, ...adviceContent };
							for (const advice of report.advices) {
								content.uuid = advice.id;
								await this.processMitigation(exclusionElement, description, content, counter, all, false, expiry);
								counter--;
							}
						}
						if (this.state.type === "cve") {
							const all = report.advices[0].cvesCount;
							let counter = all - 1;
							const content = { ...exclusionElement.content, ...cveContent };
							for (const advice of report.advices) {
								if (!advice.prominentIdentifier || advice.prominentIdentifier.startsWith("MET-")) continue;
								content.cve = advice.prominentIdentifier;
								await this.processMitigation(exclusionElement, description, content, counter, all, false, expiry);
								counter--;
							}
						}
						if (this.state.type === "library") {
							const content = { ...exclusionElement.content, ...libraryContent };
							content.version = "*"
							await this.processMitigation(exclusionElement, description, content, 0, 1, false, expiry);
						}
						this.globalExclusion = false
					}
					else {
						delete exclusionElement.report;
						const { adviceContent, cveContent, libraryContent } = exclusionElement;
						if (this.state.type === "advice") {
							await this.processMitigation(exclusionElement, description, adviceContent, 0, 1, false, expiry)
						}
						if (this.state.type === "cve") {
							await this.processMitigation(exclusionElement, description, cveContent, 0, 1, false, expiry)
						}
						if (this.state.type === "library") {
							await this.processMitigation(exclusionElement, description, libraryContent, 0, 1, false, expiry)
						}
					}
				}
				else {
					await this.excludeNonSecurity(exclusionElement, description, 0, 1, expiry)
				}
			} else {
				this.excludeMultiLicenses(exclusionElement, description, expiry)
			}
			this.setState({ excludeDialog: { ...excludeDialog, description: "" } })
		}
		else {
			this.setState({ excludeDialog: { ...excludeDialog, error: true, description: "" } })
		}
	}

	isDescriptionValid = (description) => {
		return description.length && description.replace(/ /g, "").length > 0
	}

	processMitigation = async (elementToMitigate, description, content, counter = 0, all = 1, transitive = false, expiry = null) => {
		if (!counter) counter = 0;
		const { mitigate } = this.props;
		content.description = description;
		content.reason = elementToMitigate.content.reason
		// Never send a null: a missing key is what "never expires" means to the API.
		if (expiry) content.expiry = expiry
		const domain = elementToMitigate.domain.split(":")[0]
		const finalMitigation = {
			content, domain, creatorUuid: elementToMitigate.elementToMitigate
		}
		const isFirst = counter === all - 1;
		await mitigate(finalMitigation, isFirst, counter === 0, this.state.doRecompute, transitive, this.state.applyToAllBranches);
	}

	changeTypeSelection = (e) => {
		this.setState({ type: e.target.value })
	}

	setRecomputeEvent(e) {
		const checked = e.target.checked
		this.setState({
			doRecompute: checked
		})
	}
	confirmHandler() {
		window.$("#exclude-dialog").modal("hide")
	}
	getSnapshotBeforeUpdate(prevState, prevProps) {
		const previousElement = JSON.stringify(prevProps.elementToMitigate)
		const thisElement = JSON.stringify(this.props.elementToMitigate)
		if (this.props.elementToMitigate && this.props.action !== "add") return false
		return previousElement !== thisElement
	}
	componentDidUpdate(prevState, prevProps, updated) {
		if (updated && this.props.exclusionElement && this.autoRecompute && this.autoRecompute.current) {
			if (this.props.exclusionElement.domain === "security:transitive") {
				this.autoRecompute.current.checked = true
				this.autoRecompute.current.disabled = true
			}
			else {
				this.autoRecompute.current.disabled = false
			}
			if (this.state.doRecompute !== this.autoRecompute.current.checked) {
				this.setRecomputeEvent({ target: this.autoRecompute.current })
			}
		}
	}

	render() {

		const { isGlobalExclusionAvailable, exclusionElement, domain, isMultiple } = this.props;

		let globalExclusionMessage = "";
		if (isGlobalExclusionAvailable) {
			if (this.state.type === "advice") {
				globalExclusionMessage = "Apply this exclusion to all vulnerabilities related to this component"
			}
			if (this.state.type === "cve") {
				globalExclusionMessage = "Apply exclusions to all the CVEs related to this component"
			}
			if (this.state.type === "library") {
				globalExclusionMessage = "Apply exclusion to all the versions of this library"
			}
		}



		return (
			<div className="modal fade user-modal" id="exclude-dialog" tabIndex="-1" role="dialog">
				
				
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 id="exclude-title" className="modal-title" title={`${isMultiple ? exclusionElement.map((elementToExclude) => elementToExclude.content.library.name).join(", "): ""}`}>{exclusionElement.title}</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						{!isMultiple && (!exclusionElement || !exclusionElement.title)? null :
						<div className="modal-body">
							<form role="form">
								<div className="form-group">
									<h5>Explanation:</h5>
									<textarea ref={this.excludeDialogTextarea} onChange={this.setDescriptionText} className="form-control" rows="5" id="exclude-info" placeholder="Please add a reasonable description of your action" defaultValue={this.excludeDialogTextarea.current ? this.excludeDialogTextarea.current.innerText : ""}></textarea>
									{this.state.excludeDialog.error ? <p id="exclude-error" className="alert alert-danger">Please add a reasonable description</p> : null}
								</div>
							</form>
							{domain === "security" ?
								<div>
									<h5>Type of exclusion: </h5>
									<input type="radio" name="type" value="advice" defaultChecked onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">Vulnerability</label>
									{exclusionElement.cveContent && exclusionElement.cveContent.cve && !exclusionElement.cveContent.cve.startsWith('MET-') ? <React.Fragment><input type="radio" name="type" value="cve" onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">{exclusionElement.cveContent.cve.split('-')[0]} ID</label> </React.Fragment> : null }
									{!exclusionElement.hideLibraryMitigation ? <><input type="radio" name="type" value="library" onChange={this.changeTypeSelection} /><label className="ml-1 mr-2">Library version</label></>: null}
								</div>
								: ""
							}
							{this.state.type !== "cve" &&  isGlobalExclusionAvailable[this.state.type] ?
								<React.Fragment>
									<input type="checkbox" ref={this.excludeComponent} onChange={(e) => this.setGlobalExclusion(e)} className="mr-1" /> {globalExclusionMessage}
									<br />
								</React.Fragment>
								: null
							}
							<input type="checkbox" checked={this.state.applyToAllBranches} onChange={this.setApplyToAllBranches} className="mr-1" /> Apply exclusion to all branches
							<br />
							<input type="checkbox" onChange={(e) => { this.setRecomputeEvent(e) }} className="mr-1" ref={this.autoRecompute} /> Automatically recompute the report
							<br />
							<div className="form-group mt-2">
								<label htmlFor="exclude-expiry" className="mr-1">Expires:</label>
								<select id="exclude-expiry" className="form-control"
									value={this.state.expiryOption} onChange={this.setExpiryOption}>
									{window.ExclusionExpiry.SELECTABLE_OPTIONS.map(option =>
										<option key={option.value} value={option.value}>{option.label}</option>
									)}
								</select>
								{this.state.expiryOption === window.ExclusionExpiry.CUSTOM ?
									<input type="date" id="exclude-expiry-date" className="form-control mt-1"
										min={window.ExclusionExpiry.earliestCustomExpiry()}
										value={this.state.customExpiry} onChange={this.setCustomExpiry} />
									: null
								}
								{this.state.expiryError ?
									<p id="exclude-expiry-error" className="alert alert-danger mt-1">Please pick a date later than today</p>
									: null
								}
							</div>
						</div>}

						<div className="modal-footer">
							<button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
							<button type="button" className="btn btn-primary" id="exclude-submit" onClick={this.confirmDescription} >Exclude</button>
						</div>
					</div>
				</div>
				
			</div>
		)
	}
}


export default connect(mapStateAsProps, mapDispatchAsProps)(Mitigator);